// extracted by mini-css-extract-plugin
module.exports = {"soundButton":"soundButton_soundButton__2iIdC","soundButton__img":"soundButton_soundButton__img__7ruuN"};